import { TStatusCountIcon } from '@components/StatusCount/StatusCount.interface';
import { TAdminSupplementInquiryStatus } from '@interfaces/adminSupplements';

const statusMap = {
  [TAdminSupplementInquiryStatus.New]: TStatusCountIcon.Red,
  [TAdminSupplementInquiryStatus.Recent]: TStatusCountIcon.Blue,
  [TAdminSupplementInquiryStatus.Other]: TStatusCountIcon.Yellow,
};

export const getStatusIcon = (value: TAdminSupplementInquiryStatus) => statusMap[value];
